<nb-card class="bg-transparent">
    <nb-card-header class="pb-0">
      <div class="row">
        <div class="col-lg-4 col-12 text-lg-left">
          <h4 class="fw-semibold ls-1">Truck Types</h4>
        </div>
  
        <div class="col-lg-8   col-12 text-lg-right">
          <div class="d-flex justify-content-end">
            <div class="me-3 filter-badge-wrapper">
              <button
                mat-stroked-button
                class="btn text-dark btn-sm"
                (click)="clearFilters()"
              >
                <fa-icon [icon]="faBan" class="me-2"></fa-icon>Clear Filters
              </button>
              <span *ngIf="filterCount > 0" class="filter-badge">{{filterCount}}</span>
            </div>
  
            <button
              mat-raised-button
              color="primary"
              (click)="openDialog(false)"
            >
              <fa-icon [icon]="faPlus" size="sm" class="me-2"></fa-icon>New Truck Type
            </button>
          </div>
        </div>
      </div>
        
    </nb-card-header>
    
    <nb-card-body [nbSpinner]="truckTypeLoading">
      <div class="row">
        <div class="col-12">
          <ejs-grid
            #grid
            [id]="gridName"
            [dataSource]="allTruckTypes"
            [allowPaging]="true"
            [enableHover]="false"
            [allowSelection]="true"
            (toolbarClick)="toolbarClick($event)"
            [pageSettings]="pageSettings"
            [allowSorting]="true"          
            [allowExcelExport]="true"
            [filterSettings]="filterSettings"          
            [allowTextWrap]="true"
            [allowFiltering]="true"
            [toolbar]="toolbarOptions"
            [enableStickyHeader]="true"
            [columns]="allColumns"
            [enablePersistence]="enablePersistence"
            (actionComplete)="onActionComplete($event)"
            (dataBound)="onGridDataBound()"
            (rowDataBound)="onRowDataBound($event)"
            rowHeight="38"
          >
          </ejs-grid>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
  
  <ng-template #isActiveTemplate let-data>
    <div *ngIf="data.isActive" style="color: green;">
      <fa-icon [icon]="faCheck"></fa-icon>
    </div>
    <div *ngIf="!data.isActive" style="color: darkRed;">
      <fa-icon [icon]="faTimes"></fa-icon>
    </div>
  </ng-template>
  
  <ng-template #actionTemplate let-data>
    <ng-container *ngIf="!savingTruckTypeIds.has(data.id); else truckTypeSavingSpinner">
      <div class="d-flex">
        <button
          class="btn btn-sm btn-active-primary btn-icon-hover"
          (click)="openDialog(true, data)"
        >
          <fa-icon style="cursor: pointer;" [icon]="faPen"></fa-icon>
        </button>
        <button
          class="btn btn-sm btn-active-primary btn-icon-hover ms-1"
          (click)="confirmDelete(data.id)"
        >
          <fa-icon style="cursor: pointer;" [icon]="faTrash"></fa-icon>
        </button>
      </div>
    </ng-container>
    <ng-template #truckTypeSavingSpinner>
      <mat-spinner class="row-saving-spinner" [diameter]="20"></mat-spinner>
    </ng-template>
  </ng-template>
  